module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-24.61f91271.jpg";